

import {defineComponent} from 'vue'
import IModal from "./IModal.vue";

export default defineComponent({
  name: "IModalProgress",
  components: {IModal,},
  data() {
    return {
      messages: [] as {
        severity: 'info',
        showProgressBar: true,
        allowClose: false,
        message: string,
      }[],

    }
  },
  methods: {

    push(data) {
      this.messages.push(data)
    },
    pop() {
      this.messages.pop()
    },

  },
  beforeUnmount() {
    console.log('beforeUnmount')
  },
  computed: {
    lastMessage() {
      return this.messages[this.messages.length - 1]
    }
  }


})

